import { useEffect } from "react";
import { captureAttribution } from "../analytics/attribution";

/**
 * Replaces the old RouteTracker.
 *
 * RouteTracker pushed a `virtualPageView` event on every route change. Nothing
 * ever consumed it — the GTM container has no trigger for that event — so it
 * was dead code, and worse, wiring a trigger to it later would have
 * double-counted: GA4 enhanced measurement already tracks SPA navigation via
 * history events, verified firing correctly in production.
 *
 * What the app genuinely cannot get from enhanced measurement is the Google
 * click id, which has to be read off the landing URL and kept for the session
 * so it can be stored with the lead. That is all this does now.
 */
function AttributionTracker() {
  useEffect(() => {
    captureAttribution();
  }, []);

  return null;
}

export default AttributionTracker;
